import React from 'react';
import { motion } from 'framer-motion'; // Importiere framer-motion
import BlockPayment from "./components/BlockPayment";
import PayButton from "./components/PayButton";
import BlockSummary from "../BlockElements/BlockSummary";
import BlockBilling from "./components/BlockBilling";
import BlockComment from "../BlockElements/BlockComment";
import BlockTerms from "../BlockElements/BlockTerms";
import NextPage from "../BlockElements/NextPage";

import { useReduxStore } from '../../../../redux/checkoutredux/ReduxCheckoutContext.tsx';


const PagePayment = () => {

  const store = useReduxStore(); 
  const reviewstep = store.getState().checkoutsettings.checkoutSettings.checkout_orderreview;
  console.log("Reviewstep: ",reviewstep);

  return (

    <div className="ips-pagepayment">
      <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        variants={{
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 }
        }}
        transition={{ duration: 0.7 }}
      >
        <div className="my-4"><BlockSummary pagetype="payment" store={store}/></div>
        <div className="my-4"><BlockPayment store={store} /></div>
        <div className="my-4"><BlockBilling store={store}/></div>
        {reviewstep === 'off' && <div className="my-4"><BlockComment store={store}/></div>}
        {/* <div className="my-4"><BlockTerms store={store}/></div> */}
        {reviewstep === 'off' ? (
          <div className="my-4"><PayButton pagetype="payment" store={store} /></div>
        ) : (
          <div className="my-4"><NextPage pagetype="payment" store={store} /></div>
        )}
        {/* <div className="my-4"><PayButton store={store}/></div> */}
      
        <div className="row my-4"></div>
      
        <div className="row my-4"></div>
      </motion.div>
    </div>

  );
};

export default PagePayment;